// Pre-camera landing screen. Camera access needs a user gesture, so nothing
// engine-related starts until the visitor taps in.
export interface LandingCopy {
  title: string
  intro: string
  cta?: string
}

export function showLanding(copy: LandingCopy, onStart: () => void): void {
  const root = document.getElementById('ui-root')!
  const el = document.createElement('div')
  el.className = 'landing'
  el.innerHTML = `
    <h1></h1>
    <p></p>
    <button type="button"></button>
    <div class="attribution">
      <img src="/external/xr/resources/powered-by.svg" alt="Powered by 8th Wall" />
    </div>
  `
  el.querySelector('h1')!.textContent = copy.title
  el.querySelector('p')!.textContent = copy.intro
  el.querySelector('button')!.textContent = copy.cta ?? 'Enter'
  el.querySelector('button')!.addEventListener(
    'click',
    () => {
      el.remove()
      onStart()
    },
    {once: true},
  )
  root.appendChild(el)
}

export function showStatus(text: string): () => void {
  const root = document.getElementById('ui-root')!
  const pill = document.createElement('div')
  pill.className = 'status-pill'
  pill.textContent = text
  root.appendChild(pill)
  return () => pill.remove()
}
